import React, { Component } from 'react'
import { Input, Select } from 'loyal-react'
import PropTypes from 'prop-types'
import image from '@loyal_images/products/product_placeholder.png'
import ReactImageFallback from 'react-image-fallback'
import { connect } from 'react-redux'
import '@loyal_template/donation.css'

const bgImage = {
  backgroundImage: 'url(' + image + ')',
  backgroundSize: 'cover',
  backgroundPositionY: '-17px'
}

const bgImageMobile = {
  backgroundImage: 'url(' + image + ')',
  backgroundSize: 'contain',
  backgroundPositionX: 'center',
  backgroundPositionY: '-20px',
  backgroundRepeat: 'no-repeat'
}

class Donation extends Component {
  constructor (props) {
    super(props)

    this.state = {
      value: '',
      totalPoints: this.props.pointsValue,
      handlerListInstitutions: this.props.handlerListInstitutions,
      handlerConvertionPointsToCash: this.props.handlerConvertionPointsToCash,
      handlerServiceId: this.props.handlerServiceId,
      handlerDonatedPoints: this.props.handlerDonatedPoints,
      vendorId: this.props.vendorId,
      imageUrl: this.props.imageUrl,
      institutions: this.props.institutions.map(item => ({
        text: item.name,
        value: item.id,
        serviceId: item.services[0].id,
        imageUrl: item.imageUrl
      }))
    }
  }
  numberToStrCurrency (value, decimalPlaces) {
    return value.toLocaleString('pt-br', {
      minimumFractionDigits: decimalPlaces,
      maximumFractionDigits: decimalPlaces
    })
  }
  handleValueChange = event => {
    return this.setState({
      value:
        this.state.totalPoints > event.target.value
          ? event.target.value
          : Math.floor(this.state.totalPoints)
    })
  }
  render () {
    this.numberToStrCurrency(
      this.state.totalPoints - this.state.value,
      this.props.decimalPlaces
    )

    return (
      <div className='row'>
        <div className='col-12 px-0'>
          <div className='row border-dashed-bottom border-color-ui-3 mx-0 pb-2'>
            <div className='col-12 col-md-10'>
              <div className='row mx-0'>
                <p className='col-12 txt-body-sm mb-1'>
                  Escolha a Instituição beneficiada
                </p>
                <Select
                  id='institutions'
                  label='Instituição'
                  className='col-12'
                  hasEmpty
                  displayValue='text'
                  selectedValue='value'
                  options={this.state.institutions}
                  onChange={e => this.props.handlerServiceId(e)}
                />
              </div>
            </div>
            <div className='col-12 col-md-2 px-1'>
              <div className='row mr-0 d-none d-md-flex align-items-center donation-institution-area'>
                <ReactImageFallback
                  src={this.props.imageUrl}
                  fallbackImage={image}
                  initialImage={image}
                  className='img-w-auto'
                  style={bgImage}
                  alt=''
                  aria-hidden='true'
                />
              </div>
              <div className='row mx-0 px-1 mt-2 d-block d-md-none'>
                <div className='col-6 mx-auto py-1  radius txt-center'>
                  <ReactImageFallback
                    src={this.props.imageUrl}
                    fallbackImage={image}
                    initialImage={image}
                    className='w-75'
                    style={bgImageMobile}
                    alt=''
                    aria-hidden='true'
                  />
                </div>
              </div>
            </div>
          </div>
          <div className='row ml-1 mr-0 my-2'>
            <p className='col-12 txt-body-sm mb-1'>
              Selecione o valor que deseja doar
            </p>

            <Input
              id='pontosDoados'
              className='col-6 col-md-3'
              childrenClassName='radius has-content'
              label={`Doação em ${this.props.label}`}
              type='text'
              min='1'
              placeholder={0}
              value={this.state.value}
              onBlur={this.props.handlerConvertionPointsToCash(
                this.state.value > 0 ? this.state.value : 0
              )}
              onChange={this.handleValueChange}
              disabled={!(this.state.totalPoints > 0) || !this.props.imageUrl}
            />
          </div>
          <br />
          <div
            className={`btn-loading mr-auto ml-auto ${
              this.props.isLoadingChangeAccountType ? 'd-block' : 'd-none'
            }`}
          >
            <div />
            <div />
            <div />
            <div />
          </div>
        </div>
      </div>
    )
  }
}

Donation.propTypes = {
  pointsValue: PropTypes.number,
  vendorId: PropTypes.number,
  isLoadingChangeAccountType: PropTypes.bool,
  handlerListInstitutions: PropTypes.func,
  institutions: PropTypes.array,
  handlerConvertionPointsToCash: PropTypes.func,
  handlerServiceId: PropTypes.func,
  handlerDonatedPoints: PropTypes.func,
  imageUrl: PropTypes.string,
  decimalPlaces: PropTypes.string,
  label: PropTypes.string
}

const mapStateToProps = ({ catalog: { currencyConfiguration } }) => ({
  label: currencyConfiguration.pointsName,
  decimalPlaces: currencyConfiguration.decimalPlaces
})

export default connect(
  mapStateToProps,
  null
)(Donation)



// WEBPACK FOOTER //
// ./src/features/Donation/FormDonation.js